import React from 'react';

import TypeIcon from './typeicon';
import Togglable from '../togglable';

const ThumbnailImage = Togglable(({ thumbnail, onImage404 }) => (
	<img alt="" className="rounded" src={thumbnail} width="48" height="48" onError={onImage404} />
))

const Item = ({ title, thumbnail, href, type, onImage404 }) => (
	<a className="list-group-item list-group-item-action px-3" href={href}>
		<div className="align-items-center d-flex">
			<div className="flex-shrink-0 mr-3">
				<ThumbnailImage visible={thumbnail.length !== 0} thumbnail={thumbnail} onImage404={onImage404} />
				<TypeIcon visible={thumbnail.length === 0} type={type} />
			</div>
			<div className="flex-fill">
				<h3 className="mb-0 typography-body-2">{title}</h3>
			</div>
		</div>
	</a>
)

const RelatedItems = Togglable(({ items, removeRelatedThumbnail }) => (
	<div className="list-group mb-3 mb-lg-4">
		{items.map(({title, thumbnail, href, type}, i)=><Item key={"related-"+i} title={title} thumbnail={thumbnail} href={href} type={type} onImage404={removeRelatedThumbnail.bind(null, i)} />)}
	</div>
))

export default RelatedItems;